




















































































import {Vue, Component, Prop} from 'vue-property-decorator'
import SwapPoweredBy from '@/components/SwapPoweredBy.vue'
import SwapTokenDetails from '@/components/SwapTokenDetails.vue'
import SwapTokenInfo from '@/components/SwapTokenInfo.vue'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import SwapTransactionDetailsCard from '@/components/SwapTransactionDetailsCard.vue'

@Component({
  components: {
    SwapTransactionDetailsCard,
    SwapTokenDetails,
    SwapPoweredBy,
    SwapTokenInfo,
  },
})
export default class SwapReviewStep extends Vue {
  @Prop({type: Object, required: true}) tokenToUse!: TokensTableItem
  @Prop({type: String, required: true}) amountToUse!: string
  @Prop({type: String, required: true}) amountToUseInDollar!: string
  @Prop({type: Object, required: true}) tokenToReceive!: TokensTableItem
  @Prop({type: String, required: true}) amountToReceive!: string
  @Prop({type: String, required: true}) amountToReceiveInDollar!: string
  @Prop({type: String, required: true}) minimumReceived!: string
  @Prop({type: String, required: true}) priceInverse!: string

  showBackButton: boolean = false

  mounted(): void {
    setTimeout(() => {
      this.showBackButton = true
    }, 500)
  }

  handleProceedClick(): void {
    this.$emit('proceedClick')
  }

  handleBackClick(): void {
    this.showBackButton = false
    this.$emit('backClick')
  }
}
